import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';
import Input from '@/components/base/Input';

type InputSearchProps = { onChange: (e: React.ChangeEvent<HTMLInputElement>) => void };

export function InputSearch({ onChange }: InputSearchProps) {
    const { t } = useTranslation('commons');
    return (
        <div className="px-3">
            <Input
                id="search-input"
                inputStyle="search"
                noBorder={true}
                aria-label={t('add_social_profiles.search_social_profiles')}
                onChange={onChange}
                placeholder={t('add_social_profiles.search_social_profiles')}
                beforeInput={<Icon icon="search" />}
            />
        </div>
    );
}
